import { render, staticRenderFns } from "./InvestmentsGutmann.vue?vue&type=template&id=8bfc738a&scoped=true"
import script from "./InvestmentsGutmann.vue?vue&type=script&lang=js"
export * from "./InvestmentsGutmann.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bfc738a",
  null
  
)

export default component.exports